import script from "./updateAccountInstitutePreferenceForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./updateAccountInstitutePreferenceForm.vue?vue&type=script&setup=true&lang=ts"

import "./updateAccountInstitutePreferenceForm.vue?vue&type=style&index=0&id=295a459e&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-295a459e"]])

export default __exports__